import {
  Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, XAxis, YAxis,
} from 'recharts'
import { BarChart3 } from 'lucide-react'
import { ChartCard } from '@/components/common'
import { Skeleton } from '@/components/ui/skeleton'
import { ErrorState } from '@/components/common/ErrorState'
import { EmptyState } from '@/components/common/EmptyState'
import { useDepartmentHeadcount } from '../api'

/**
 * Headcount per department, with the value printed above each bar as in the design.
 *
 * <p>The chart height is an explicit pixel value rather than a percentage: Recharts'
 * ResponsiveContainer measures its parent, and inside the card's flex column a percentage
 * height resolves to zero, which collapses the plot onto the top edge.
 */
export function DepartmentHeadcountCard() {
  const { data, isLoading, error, refetch } = useDepartmentHeadcount()

  return (
    <ChartCard title="Department-wise Headcount" icon={BarChart3}>
      {isLoading && <Skeleton className="my-4 h-[220px] w-full" />}
      {error != null && <ErrorState error={error} onRetry={() => void refetch()} />}
      {data && data.length === 0 && (
        <EmptyState title="No departments yet" description="Add departments to see headcount here." />
      )}

      {data && data.length > 0 && (
        <div style={{ height: 260 }} className="w-full py-2">
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data} margin={{ top: 22, right: 8, bottom: 0, left: -14 }} barCategoryGap="28%">
              <CartesianGrid stroke="var(--color-border)" vertical={false} />
              <XAxis
                dataKey="department"
                tickLine={false}
                axisLine={false}
                tick={{ fill: 'var(--color-muted)', fontSize: 11 }}
                dy={6}
              />
              <YAxis
                tickLine={false}
                axisLine={false}
                tick={{ fill: 'var(--color-muted)', fontSize: 11 }}
                width={46}
              />
              <Bar
                dataKey="headcount"
                fill="var(--color-primary)"
                radius={[4, 4, 0, 0]}
                maxBarSize={44}
                isAnimationActive={false}
              >
                <LabelList
                  dataKey="headcount"
                  position="top"
                  offset={8}
                  className="fill-[var(--color-heading)]"
                  fontSize={12}
                  fontWeight={600}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </ChartCard>
  )
}
